




















































import { computed, defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { ProfileFileType } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseInputFile from "@/components/BaseInputFile";
import BannerCropModal from "./components/BannerCropModal.vue";
import UserBackground from "./components/UserBackground.vue";
import useProfileFileController from "../hooks/useProfileFileController";

export default defineComponent({
  name: "UserBackgroundController",
  components: { UserBackground, BannerCropModal, BaseButton, BaseInputFile },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
    nsfw: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const fieldName = computed(() => (props.nsfw ? "backgroundNsfw" : "background"));
    const hasFile = computed(() => !!props.user[fieldName.value]);

    const {
      newSrc,
      showCropModal,
      loading,
      deleting,
      onUploadClick,
      onCropClose,
      onCropped,
      onDelete,
    } = useProfileFileController({
      getUserId: () => props.user.id,
      getType: () => (props.nsfw ? ProfileFileType.BACKGROUND_NSFW : ProfileFileType.BACKGROUND),
      onUploaded: file => {
        emit("update", file);
      },
      onDeleted: () => {
        emit("update", null);
      },
    });

    return {
      loading,
      showCropModal,
      newSrc,
      hasFile,
      deleting,
      onDelete,
      onCropClose,
      onUploadClick,
      onCropped,
    };
  },
});
